import { z } from 'zod';

/** Malible's Expo and Bitrise tokens as `GET /platform/providers` shows them: never the token (SPEC decision 19). */
export const PlatformProvider = z.object({
  provider: z.enum(['expo', 'bitrise']),
  configured: z.boolean(),
  account: z.string().nullable(),
  workspace: z.string().nullable(),
  updatedAt: z.string().nullable(),
  updatedBy: z.object({ id: z.string().nullable(), label: z.string() }).nullable(),
});
export type PlatformProvider = z.infer<typeof PlatformProvider>;

export const PlatformProviders = z.object({
  source: z.enum(['secrets_manager', 'environment']),
  editable: z.boolean(),
  expo: PlatformProvider,
  bitrise: PlatformProvider,
});
export type PlatformProviders = z.infer<typeof PlatformProviders>;
